module.exports = __webpack_public_path__ + "static/media/studenOrangeIcon.fa4c7494.png";